// extracted by mini-css-extract-plugin
module.exports = {"root":"Patient_root__3xUJ6"};